import {
  getItemSku,
  getDiscount,
  getItemCategory,
  getItemCategory2,
  getItemCategory4,
  getItemShippingTier,
} from '../../utils';

export async function itemsFromItem(context: Record<string, any>, event: string) {
  const { item, orderForm } = context;
  return [
    {
      index: 0,
      quantity: 1,
      item_id: item?.productId || item?.item_group_id || item?.sku || null,
      item_category2: getItemCategory2(item),
      item_category4: getItemCategory4(item),
      item_shipping_tier: event === 'REMOVE_FROM_CART' ? getItemShippingTier(orderForm, item) : null,
      price: item?.listPrice || item?.price || 0,
      item_ref: item?.refId || item?.item_ref || item?.additionalProperty?.find((i: { name: string }) => i.name === "RefId").value || null,
      item_brand: item?.additionalInfo?.brandName || item?.item_brand || item?.brand?.name || null,
      item_sku: item?.sku || item?.id || item?.item_id || (await getItemSku(item)) || null,
      item_name: item?.name || item?.item_name || null,
      item_category: getItemCategory(item) || null,
      item_variant: (item?.skuName || item?.item_variant || item?.name).split(/[-/]/)[0].trim() || null,
      item_variant2: item?.size || item?.itemAttributes?.size || (item?.skuName || item?.name)?.split(/[-/]/).pop()?.trim() || null,
      discount: getDiscount(item),
      item_list_name: getItemCategory(item) || null,

      item_url: item?.item_url || null, // add_to_cart dito
    },
  ];
}
